module.exports = __webpack_public_path__ + "img/html5.ce6e5ba0.svg";